
const contacts = [
  {
    icon: 'ri-phone-line',
    title: '전화 문의',
    main: '02-3487-2025',
    sub: '평일 09:00 - 18:00 (주말/공휴일 휴무)',
    color: 'bg-emerald-50',
    iconColor: 'text-emerald-600',
  },
  {
    icon: 'ri-mail-line',
    title: '이메일 문의',
    main: 'homedr365@gmail.com',
    sub: '영업일 기준 1~2일 내 답변',
    color: 'bg-teal-50',
    iconColor: 'text-teal-600',
  },
  {
    icon: 'ri-kakao-talk-fill',
    title: '카카오톡 채널',
    main: '@자연담은',
    sub: '평일 09:00 - 18:00 실시간 상담',
    color: 'bg-yellow-50',
    iconColor: 'text-yellow-500',
  },
];

export default function ContactInfo() {
  return (
    <section className="py-12 md:py-16 bg-white border-b border-gray-100">
      <div className="max-w-5xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {contacts.map((c) => (
            <div
              key={c.title}
              className={`${c.color} rounded-2xl p-6 flex flex-col items-center text-center gap-3 hover:shadow-md transition-shadow`}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-full bg-white shadow-sm`}>
                <i className={`${c.icon} ${c.iconColor} text-2xl`}></i>
              </div>
              <div>
                <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-1">{c.title}</p>
                <p className="text-base font-bold text-gray-900">{c.main}</p>
                <p className="text-xs text-gray-500 mt-1">{c.sub}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
